import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {AppService} from '@app/services/app.service';
import {Store} from '@ngxs/store';
import {LocalUser, LocalUserState} from '@app/state/local-user.state';
import {SmartsuppService} from '@app/modules/shared/services/smartsupp.service';
import {ClassroomState, ClassroomStateModel} from '@app/state/classroom-state.service';
import {ClassroomInitService} from '@app/modules/shared/services/classroom-init.service';

@Component({
  selector: 'app-classroom-closed',
  templateUrl: './classroom-closed.component.html',
  styleUrls: ['./classroom-closed.component.css']
})
export class ClassroomClosedComponent implements OnInit {
  public selectedClassId: number;
  public smartsuppUsername: string;
  public localUser: LocalUser;
  public classroom: ClassroomStateModel;

  protected readonly window: Window = window;

  constructor(
    private activatedRoute: ActivatedRoute,
    private smartsuppService: SmartsuppService,
    private appService: AppService,
    private store: Store
  ) {}

  public ngOnInit(): void {
    this.smartsuppUsername = this.smartsuppService.buildUsername(false);
    this.store.select(LocalUserState).subscribe((localUser: LocalUser) => {
      this.localUser = localUser;
    });
    this.store.select(ClassroomState).subscribe((classroom: ClassroomStateModel) => {
      this.classroom = classroom;
    });
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      this.selectedClassId = params.classId;
    });
  }

  public tryAgain(): void {
    window.location.href = `/${this.classroom.roomNum}`;
  }
}
